export const emailTips = {
  80187: '请填写客户邮箱，一个邮箱只能绑定一家企业',
  80327: '请填写客户邮箱，一个邮箱只能绑定一家企业',
  80210: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80211: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80265: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80280: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80282: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
  80326: '重要提示：填写企业联系人姓名、手机号、身份证号需三者实名认证为同一人！！！',
};

// 报价页下方算出价格的提示文案
export const quotePriceTips = {
  80294: '当前费率仅供参考，最终以录入人员信息承保报价为准',
};

// 80221这类产品，不需要选人员和职业，所有其他责任都只跟随主险联动
export const singleClauseProductMap = {
  80221: {
    mainClauseCode: 'GP8022149746228',
    additionalClause: {
      name: '附加食品、饮料责任条款（可选）',
      clauseCodes: ['GP8022122447225', 'GP8022119698930', 'GP8022103398399'],
    },
  },
};

// 鼎和1、2个月不支持整单退保产品
export const DINGHE_PRODUCRCT_IDS = ['80190'];

// 有些产品会下架一些险种，后续不再售了，但是老产品的订单维度还是需要展示用户之前投保的
export const DEPRECATED_CLAUSES_IDS = {
  80156: ['006', '007', '008'],
  80281: [
    'GP8023045233661',
    'GP8023047424723',
    'GP8023083579125',
    'GP8023038639933',
    'GP8023081714593',
  ],
};

/*
 * 有些产品会下架一些险种的保额选项（直接服务端删除，不是前端隐藏），
 * 但是老产品的订单维度还是需要展示用户之前投保的，这里根据保额做下选项映射
 */
export const DELETED_CLAUSES_OPTIONS_IDS = {
  80204: {
    GP8020485142212_80: '80万元',
    GP8020485142212_100: '100万元',
    GP8020458390870_9: '9万元',
    GP8020458390870_11: '11万元',
  },
  80202: {
    GP8020285142150_80: '80万元',
    GP8020285142150_100: '100万元',
    GP8020258390932_8: '8万元',
    GP8020258390932_10: '10万元',
  },
};

// JYXQ-1818 不需要进行ocr识别营业执照回填的产品id
export const notOcrProductIds = ['80310', '80297', '80221', '80132']

// 80325 80326 保障责任要是外露按钮的那种样式
export const outOrderClauseCodes = ['GP8032562239910', 'GP8032649454345'];



// WEBPACK FOOTER //
// ./src/util/GLOBAL.js